import session_connect from './session/qqconnect'

/**
 * 检查登录态
 */
export default function (param) {
  if (typeof param === 'object' && param !== null && param.qq_appid && param.openid && (param.accessToken || param.payToken)) {
    return new session_connect({
      qq_appid: param.qq_appid,
      openid: param.openid,
      accessToken: param.accessToken,
      payToken: param.payToken
    });
  }
  return false;
}
